import {AppDispatch} from "../../../store";
import ServerStateDispatcher from "../ServerStateDispatcher";
import { SoundsService } from "../../SoundsService";
import {AnimationActionCreators} from "../../../store/reducers/animation/action-creation";

export default class MiddlewareAbility {
    static async show(ServerState, dispatch: AppDispatch){


        dispatch(AnimationActionCreators.setShowMiddleware({tableKey:ServerState.tableKey, side: ServerState.side}));
        
        SoundsService.playMiddlewareAbility(ServerState.card_id);


        if (ServerState.result !== undefined && ServerState.result !== null) {

            if(ServerState?.double_state !== true){
                ServerState.result = [ServerState.result];
            }

            for (let i = 0; i < Object.keys(ServerState.result).length; i++) {
                await ServerStateDispatcher.dispatchState({
                    sign: 'mdl_local_played_card_result',
                    state: ServerState.result[i]
                }, dispatch);
            }
        }
     /*   if(ServerState.result !== undefined  && ServerState.result !== null) {
                await ServerStateDispatcher.dispatchState({
                    sign: 'mdl_local_played_card_result',
                    state: ServerState.result
                }, dispatch);
        } */

        await new Promise(r => setTimeout(r, 700));

        dispatch(AnimationActionCreators.setShowMiddleware({tableKey:null, side: null}));
    }
}
